exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bar-chart .recharts-tooltip-cursor {\n  fill: #eee; }\n\n.bar-chart .simple-bar-chart-tooltip {\n  background-color: white;\n  height: 100px;\n  border-color: black;\n  border-style: solid;\n  text-align: center; }\n  .bar-chart .simple-bar-chart-tooltip .tooltip-label {\n    color: red;\n    font-weight: bold;\n    font-size: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/core/Chart/CartesianChart/BarChart/SimpleBarChart/style.scss
// module id = 1030
// module chunks = 0